/*
 * 头部
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-07-31 20:03:34
 * @Last Modified by: kq.zheng
 * @Last Modified time: 2020-04-29 15:57:01
 */

import * as React from 'react';
import PropTypes from 'prop-types';
import { DownloadOutlined, LogoutOutlined, ShopOutlined, UserOutlined, MessageOutlined } from '@ant-design/icons';
import { Avatar, Popover, Badge } from 'antd';
import { LayoutBreadcrumb } from 'components';

import './index.less';

const prefixCls = 'eh-header-component';

class Header extends React.Component {
	render() {
		const {
			name,
			storeName = '',
			onLogout,
			onDownload,
			avatar,
			onChangeShop,
			onClickPcMsg,
			messageBadgeCount,
			routes
		} = this.props;

		const popoverMenus = (
			<div
				className={`${prefixCls}-popmenu`}
				onClick={onChangeShop}
			>
				切换店铺
			</div>
		);

		return (
			<header className={prefixCls}>
				<LayoutBreadcrumb
					name={null}
					btns={[]}
					helpBtn={null}
					routes={routes}
					hasHelpDocumentsBtn={true}
				/>
				<div className={`${prefixCls}-right`}>
					<div className={`${prefixCls}-right-user`}>
						<Avatar
							src={avatar}
							icon={<UserOutlined />}
							style={{
								background: '#FFF',
								color: '#18203F',
								border: '1px solid rgba(0,0,0,0.08)',
								width: '32px',
								height: '32px'
							}}
						/>
						<span className={`${prefixCls}-right-user-name`}>
							{name}
						</span>
					</div>
					<Popover content={popoverMenus} title="">
						<div className={`${prefixCls}-right-store`}>
							<ShopOutlined style={{ fontSize: 20 }} />
							<span>{storeName}</span>
						</div>
					</Popover>

					<div style={{ cursor: 'pointer', marginLeft: 26 ,marginTop:5 }}>
						<Badge dot={!!messageBadgeCount} >
							<MessageOutlined
								style={{ fontSize: 20 }}
								onClick={onClickPcMsg}
							/>
						</Badge>
					</div>
					<DownloadOutlined
						style={{ fontSize: 20, cursor: 'pointer', marginLeft: 26 }}
						id="export-center-icon"
						onClick={onDownload} />
					<LogoutOutlined
						style={{ fontSize: 20, cursor: 'pointer', marginLeft: 26 }}
						onClick={onLogout} />
				</div>
			</header>
		);
	}
}

Header.defaultProps = {
	name: '',
	avatar: '',
	onLogout: f => f,
	onChangeShop: f => f,
	onDownload: f => f,
};

Header.propTypes = {
	name: PropTypes.string, // 登陆名
	storeName: PropTypes.string, // 当前操作店铺
	avatar: PropTypes.string, // 头像
	isOpen: PropTypes.bool.isRequired, // 当前左侧菜单栏是否展开
	onLogout: PropTypes.func, // 退出登录按钮被点击
	onDownload: PropTypes.func, // 点击下载按钮
	onChangeShop: PropTypes.func, // 切换按钮
	routes: PropTypes.object,
};

export default Header;
